import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { getUserAddresses, createUserAddress, updateuserAdderss, getuserAddress } from '../../services/Apis';
import FeildModel from '../../Popup\'s/FeildModel';
import { useFilter } from '../../context/FilterContext';

const ShippingDetails = () => {
  // Form field meta used by popup component
  const fields = [
    { name: 'fullName', label: 'Full Name' },
    { name: 'parentName', label: 'S/o,D/o,W/o' },
    { name: 'houseNo', label: 'House / Flat No' },
    { name: 'street', label: 'Street' },
    { name: 'village', label: 'Village' },
    { name: 'mandal', label: 'Mandal' },
    { name: 'landmark', label: 'Land Mark' },
    { name: 'city', label: 'City' },
    { name: 'district', label: 'District' },
    { name: 'state', label: 'State' },
    { name: 'country', label: 'Country' },
    { name: 'pincode', label: 'PIN Code' },
    { name: 'phoneNumber', label: 'Mobile Number' }
  ];
  const [addresses, setAddresses] = useState([]);
  const { token } = useFilter();
  const [openAddressModal, setOpenAddressModal] = useState(false);
  const [editingAddressId, setEditingAddressId] = useState(null);
  const [addressForm, setAddressForm] = useState({
    fullName: '', parentName: '', houseNo: '', street: '', village: '', mandal: '', district: '', city: '', state: '', country: 'India', pincode: '', phoneNumber: ''
  });
  const [addressError, setAddressError] = useState('');
  const [addressSuccess, setAddressSuccess] = useState('');

  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const res = await getUserAddresses(token);
        setAddresses((res || []).filter(addr => !addr.isDeleted));
      } catch (err) {
        setAddresses([]);
      }
    };
    fetchAddresses();
  }, [token]);

  const handleAddressChange = (e) => {
    const { name, value } = e.target;
    if (name === 'phoneNumber') {
      if (/^\d{0,10}$/.test(value)) {
        setAddressForm(prev => ({ ...prev, [name]: value }));
      }
    } else if (name === 'pincode') {
      if (/^\d{0,6}$/.test(value)) {
        setAddressForm(prev => ({ ...prev, [name]: value }));
      }
    } else {
      // For all other fields including city
      setAddressForm(prev => ({
        ...prev,
        [name]: value,
        // Clear any existing error for this field
        [`${name}Error`]: undefined
      }));
    }
  };

  const handleAddressSubmit = async (e) => {
    e.preventDefault();
    setAddressError('');
    setAddressSuccess('');
    if (!/^\d{10}$/.test(addressForm.phoneNumber)) {
      setAddressError('Phone number must be exactly 10 digits.');
      return;
    }
    if (!/^\d+$/.test(addressForm.pincode)) {
      setAddressError('PIN Code must be numeric.');
      return;
    }
    const payload = {
      name: addressForm.fullName.trim(),
      phoneNumber: addressForm.phoneNumber,
      parentName: addressForm.parentName.trim(),
      houseNo: addressForm.houseNo,
      villageOrTown: addressForm.village.trim(),
      landmark: addressForm.landmark.trim(),
      mandal: addressForm.mandal.trim(),
      district: addressForm.district.trim(),
      street: addressForm.street.trim(),
      city: addressForm.city.trim(),
      country: addressForm.country.trim(),
      state: addressForm.state.trim(),
      pincode: addressForm.pincode
    };
    try {
      if (editingAddressId) {
        await updateuserAdderss(editingAddressId, payload, token);
      } else {
        await createUserAddress(payload, token);
      }
      setAddressSuccess('Address saved successfully!');
      setOpenAddressModal(false);
      setEditingAddressId(null);
      const updated = await getuserAddress(token);
      setAddresses((updated.addresses || []).filter(addr => !addr.isDeleted));
    } catch (err) {
      setAddressError(err?.response?.data?.message || 'Failed to save address.');
    }
  };

  const handleCloseModal = () => setOpenAddressModal(false);

  const openAddModal = () => {
    setAddressForm({
      fullName: '', parentName: '', houseNo: '', street: '', village: '', mandal: '', district: '', city: '', state: '', country: 'India', pincode: '', phoneNumber: ''
    });
    setEditingAddressId(null);
    setOpenAddressModal(true);
  };

  const openEditModal = (addr) => {
    setAddressForm({
      fullName: addr.name || '',
      parentName: addr.parentName || '',
      houseNo: addr.houseNo || '',
      street: addr.street || '',
      village: addr.village || '',
      mandal: addr.mandal || '',
      district: addr.district || '',
      city: addr.city || '',
      state: addr.state || '',
      country: addr.country || 'India',
      pincode: addr.pincode || '',
      phoneNumber: addr.phoneNumber || ''
    });
    setEditingAddressId(addr.id);
    setOpenAddressModal(true);
  };

  return (
    <Box sx={{ px: { xs: 1, md: 3 }, py: { xs: 2, md: 0 } }}>
      <Typography sx={{ fontWeight: 600, fontSize: 22, mb: 2, fontFamily: 'Poppins' }}>
        Shipping Details
      </Typography>
      <Typography sx={{ fontWeight: 500, fontSize: 16, mb: 2, fontFamily: 'Poppins' }}>
        Saved Address
      </Typography>
      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', mb: 3 }}>
        {addresses.length === 0 && (
          <Typography sx={{ color: '#888', fontFamily: 'Poppins' }}>No addresses found.</Typography>
        )}
        {addresses.map((addr, idx) => (
          <Box
            key={addr.id}
            sx={{
              bgcolor: '#fafafa',
              border: '1px solid #e0e0e0',
              borderRadius: 2,
              p: 2,
              minWidth: 270,
              maxWidth: 340,
              flex: 1,
              position: 'relative'
            }}
          >
            <Typography sx={{ fontWeight: 600, fontSize: 16, mb: 0.5, fontFamily: 'Poppins' }}>
              {addr.name}
            </Typography>
            {addr.parentName && (
              <Typography sx={{ fontSize: 14, color: '#666', mb: 0.5, fontFamily: 'Poppins', fontStyle: 'italic' }}>
                S/o, D/o: {addr.parentName}
              </Typography>
            )}
            <Typography sx={{ fontSize: 14, color: '#444', mb: 0.5, fontFamily: 'Poppins' }}>
              {addr.houseNo}, {addr.street}, {addr.village && `${addr.village},`} {addr.mandal && `${addr.mandal},`} {addr.district && `${addr.district},`} {addr.city}, {addr.state}, {addr.country} - {addr.pincode}
            </Typography>
            <Typography sx={{ fontSize: 14, color: '#444', fontFamily: 'Poppins' }}>
              {addr.phoneNumber}
            </Typography>
            <Typography sx={{ fontSize: 14, color: '#888', fontFamily: 'Poppins', mb: 1 }}>
              {addr.email}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
              <Typography variant='body2' sx={{ fontWeight: 500, fontSize: 12, color: '#000', fontFamily: 'Poppins' }}>
                {addr.type || ''}
              </Typography>
              <Box sx={{ flex: 1 }} />
              <Button
                onClick={() => openEditModal(addr)}
                variant="outlined"
                size="small"
                sx={{
                  borderRadius: 10,
                  fontSize: 13,
                  textTransform: 'none',
                  px: 2,
                  borderColor: '#bbb',
                  color: '#222',
                  fontWeight: 400,
                  bgcolor: '#f3f3f3'
                }}
              >
                Edit
              </Button>
            </Box>
          </Box>
        ))}
      </Box>
      <Button
        variant="contained"
        size='small'
        sx={{
          bgcolor: '#C1440E',
          color: '#fff',
          borderRadius: 2,
          fontWeight: 600,
          fontSize: 16,
          px: 3,
          py: 1.2,
          textTransform: 'none',
          boxShadow: 'none',
          '&:hover': { bgcolor: '#a63a0a' }
        }}
      onClick={openAddModal}
        >
        Add New Address
      </Button>
      {/* Address form dialog */}
      <FeildModel
        open={openAddressModal}
        handleClose={handleCloseModal}
        fields={fields}
        addressForm={addressForm}
        handleAddressChange={handleAddressChange}
        handleAddressSubmit={handleAddressSubmit}
        addressError={addressError}
        addressSuccess={addressSuccess}
        setAddressForm={setAddressForm}
      />
    </Box>
  );
};

export default ShippingDetails;